import { Components, Theme } from "@mui/material";

export const MuiTab: Components<Theme>["MuiTab"] = {};
